import React from 'react'
import useSWR from 'swr';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

function Toppercarousel() {
   const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;
  const fetcher = (...args) => fetch(...args).then(res => res.json());
  const url = `${baseUrl}/${school}/items/toppers?fields=*.*.*`;


  const { data, error } = useSWR(url, fetcher);
  if (error) {
    return <div>Error...</div>
  }
  if (!data) {
    return <div>No data...</div>
  }
  return (
    <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true} showIndicators={false} style={{ padding: '0px 10px', margin: '5px 5px' }}>


      {data.data.map((item, i) => {
        return <div style={{ background: '#e9e9e9' }} key={i}>
          <center className='toppername' style={{color:"black"}} > {item.name} </center>
          <img
            className="d-block"
            src={item?.photo?.data?.full_url?.replace('http://', 'https://')}
            alt="First slide"
            style={{
              width: '100%',
              display: 'flex',
              margin: 'auto',
              justifyContant: 'center',
              height: '300px',
              border: '1px solid #9E9E9E',
              padding: '7px',
              borderRadius: '5px'
            }}
          />
          <p className='classpercent' style={{color:"black"}}> <b>Class {item.class} <br /> {item.subject} ({item.percentage}%) </b></p>
        </div>

      })}

    </Carousel>
  )
}

export default Toppercarousel
